import React, { useState, useEffect, useContext } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setSessionData, getSessionData } from "../../cache";

function Addexregularsecond11() {
  const {
    class11exregulartudent,
    setClass11exregulartudent,
    setClass11Candidateid,
    setClass11Castecode,
    setClass11Divyangcode,
    class11exregularmode,
  } = useContext(ContextBoard);
  const [loading, setLoading] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAllDataPresent, setIsAllDataPresent] = useState(false);

  const [casteList, setCasteList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);

  const [fieldsMissing, setFieldsMissing] = useState({
    fatherMissing: false,
    motherMissing: false,
    dobMissing: false,
    genderMissing: false,
  });

  const Navigate = useNavigate();
  useEffect(() => {
    if (
      !class11exregulartudent ||
      Object.keys(class11exregulartudent).length === 0
    ) {
      Navigate("/class-xi-add-ex-regular-jac");
    } else {
      const casteList = getSessionData("casteList") || [];
      const divyangList = getSessionData("divyangList") || [];
      const mediumList = getSessionData("mediumList") || [];

      setCasteList(Array.isArray(casteList) ? casteList : []);
      setDivyangList(Array.isArray(divyangList) ? divyangList : []);
      setMediumList(Array.isArray(mediumList) ? mediumList : []);
      setFieldsMissing({
        fatherMissing: !class11exregulartudent.fatheR_NAME,
        motherMissing: !class11exregulartudent.motheR_NAME,
        dobMissing: !(
          class11exregulartudent.dob || class11exregulartudent.doB_1
        ),
        genderMissing: !class11exregulartudent.gender,
      });
    }
  }, [Navigate]);

  useEffect(() => {
    setIsAllDataPresent(
      !fieldsMissing.fatherMissing &&
        !fieldsMissing.motherMissing &&
        !fieldsMissing.dobMissing &&
        !fieldsMissing.genderMissing
    );
  }, [fieldsMissing]);

  const handlePreview = () => {
    const newErrors = {};
    const trimmed = (val) => (val || "").trim();
    const candidateName = trimmed(class11exregulartudent.candidatE_NAME);
    const fathersName = trimmed(class11exregulartudent.fatheR_NAME);
    const mothersName = trimmed(class11exregulartudent.motheR_NAME);

    if (candidateName) {
      if (
        fathersName &&
        mothersName &&
        candidateName.toLowerCase() === fathersName.toLowerCase() &&
        candidateName.toLowerCase() === mothersName.toLowerCase()
      ) {
        newErrors.candidatE_NAME =
          "Candidate name cannot be the same as Father's and Mother's name.";
        newErrors.fatheR_NAME =
          "Father's name cannot be the same as Candidate and Mother's name.";
        newErrors.motheR_NAME =
          "Mother's name cannot be the same as Candidate and Father's name.";
        toast.error(
          "All names are the same! Candidate, Father's name, and Mother's name cannot be the same."
        );
      } else {
        if (
          fathersName &&
          candidateName.toLowerCase() === fathersName.toLowerCase()
        ) {
          newErrors.candidatE_NAME =
            "Candidate name cannot be the same as Father's name.";
          newErrors.fatheR_NAME =
            "Father's name cannot be the same as Candidate name.";
          toast.error(
            "Duplicate names! Candidate name cannot be the same as Father's name."
          );
        }
        if (
          mothersName &&
          candidateName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.candidatE_NAME =
            "Candidate name cannot be the same as Mother's name.";
          newErrors.motheR_NAME =
            "Mother's name cannot be the same as Candidate name.";
          toast.error(
            "Duplicate names! Candidate name cannot be the same as Mother's name."
          );
        }
        if (
          fathersName &&
          mothersName &&
          fathersName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.fatheR_NAME =
            "Father's name cannot be the same as Mother's name.";
          newErrors.motheR_NAME =
            "Mother's name cannot be the same as Father's name.";
          toast.error(
            "Duplicate names! Father's name cannot be the same as Mother's name."
          );
        }
      }
    }
    if (fieldsMissing.fatherMissing && !class11exregulartudent.fatheR_NAME) {
      newErrors.fatheR_NAME = "Father Name is required.";
    }
    if (fieldsMissing.motherMissing && !class11exregulartudent.motheR_NAME) {
      newErrors.motheR_NAME = "Mother Name is required.";
    }
    if (
      fieldsMissing.dobMissing &&
      !(class11exregulartudent.dob || class11exregulartudent.doB_1)
    ) {
      newErrors.dob = "Date of Birth is required.";
    }
    // if (fieldsMissing.genderMissing && !class11exregulartudent.gender) {
    //   newErrors.gender = "Gender is required.";
    // }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setIsPreviewed(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Focus first error field if needed
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    }
  };

  const handleButtonClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    const token = sessionStorage.getItem("tokenclassxi");

    const insertPayload = {
      CANDIDATE_CODE: class11exregulartudent.candidatE_ID || "",
      REGISTRATION_NO: class11exregulartudent.registratioN_ID_CL_11 || "",
      CL_10_EXAM_YEAR: class11exregulartudent.cL_10_EXAM_YEAR || "",
      CL_10_ROLL_CODE: class11exregulartudent.schooL_CODE || "",
      CANDIDATE_NAME: class11exregulartudent.candidatE_NAME || "",
      GENDER: class11exregulartudent.gender || "",
      DOB: class11exregulartudent.dob || "",
      FATHER_NAME: class11exregulartudent.fatheR_NAME || "",
      MOTHER_NAME: class11exregulartudent.motheR_NAME || "",
      RELIGION: class11exregulartudent.religion || "",
      AADHAR_CARD: class11exregulartudent.aadhaR_CARD || "",
      DIVYANG: class11exregulartudent.divyang || "",
      CAST: class11exregulartudent.cast || "",
      CONTACT_NO: class11exregulartudent.contacT_NO || "",
      EMAIL_ID: class11exregulartudent.emaiL_ID || "",
      AREA: class11exregulartudent.area || "",
      STATE: class11exregulartudent.state || "",
      DISTRICT_ID: class11exregulartudent.districT_ID || "",
      BLOCK: class11exregulartudent.block || "",
      ADDRESS: class11exregulartudent.address || "",
      PINCODE: class11exregulartudent.pincode || "",
      CLASS_ROLL_NO: class11exregulartudent.clasS_ROLL_NO || "",
      SECTION: class11exregulartudent.section || "",
      STREAM: class11exregulartudent.faculty || "",
      APAAR_ID: class11exregulartudent.apaaR_ID || "",
      NATIONALITY: class11exregulartudent.nationality || "",
      REGISTRATION_SESSION:
        class11exregulartudent.registratioN_SESSION_CL_11 || "",
      SCHOOL_DIST_CODE: sessionStorage.getItem("district") || "",
      STUDENT_EXAM_CATEGORY:
        class11exregulartudent.studenT_EXAM_SUB_CATEGORY || "",
      MEDIUM_OF_EXAM: class11exregulartudent.mediuM_OF_EXAM || "",
    };

    let payload = {};
    if (
      class11exregulartudent.faculty === "SCIENCE" ||
      class11exregulartudent.faculty === "COMMERCE"
    ) {
      payload = {
        ...insertPayload,
        subjecT_1_A_TYPE: "CL",
        subjecT_1_A_CODE: class11exregulartudent.suB1?.trim() || "",
        subjecT_1_B_TYPE: "MB",
        subjecT_1_B_CODE: class11exregulartudent.suB2?.trim() || "",
        subjecT_2_TYPE: "C1",
        subjecT_2_CODE: class11exregulartudent.suB3?.trim() || "",
        subjecT_3_TYPE: "C2",
        subjecT_3_CODE: class11exregulartudent.suB4?.trim() || "",
        subjecT_4_TYPE: "O1",
        subjecT_4_CODE: class11exregulartudent.suB5?.trim() || "",
        subjecT_5_TYPE: "O2",
        subjecT_5_CODE: class11exregulartudent.suB6?.trim() || "",
        subjecT_6_TYPE: "AL",
        subjecT_6_CODE: class11exregulartudent.suB7?.trim() || "",
      };
    } else if (class11exregulartudent.faculty === "ARTS") {
      payload = {
        ...insertPayload,
        subjecT_1_A_TYPE: "CL",
        subjecT_1_A_CODE: class11exregulartudent.suB1?.trim() || "",
        subjecT_1_B_TYPE: "MB",
        subjecT_1_B_CODE: class11exregulartudent.suB2?.trim() || "",
        subjecT_2_TYPE: "EL",
        subjecT_2_CODE: class11exregulartudent.suB3?.trim() || "",
        subjecT_3_TYPE: "O1",
        subjecT_3_CODE: class11exregulartudent.suB4?.trim() || "",
        subjecT_4_TYPE: "O2",
        subjecT_4_CODE: class11exregulartudent.suB5?.trim() || "",
        subjecT_5_TYPE: "O3",
        subjecT_5_CODE: class11exregulartudent.suB6?.trim() || "",
        subjecT_6_TYPE: "AL",
        subjecT_6_CODE: class11exregulartudent.suB7?.trim() || "",
      };
    }
    try {
      setLoading(true);
      // console.log(isEditMode);
      // const apiEndpoint =
      //   class11mode === "edit"
      //     ?
      //     : `${config.API_BASE_URL}/InsertStudent_CL11`;

      const response = await fetch(
        `${config.API_BASE_URL}/InsertDataEXRegularStudentMaster_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setLoading(false);
        Swal.fire("Success", "Your data added successfully!", "success").then(
          () => {
            // Executes only after user clicks OK
            setClass11Candidateid(result.data.candidatE_CODE || "");
            setClass11Castecode(result.data.cast || "");
            setClass11Divyangcode(result.data.divyang || "");
            Navigate("/class-xi-upload-document");
          }
        );
      } else {
        setLoading(false);
        Swal.fire(
          "Error",
          result.message || "Failed to submit student details.",
          "error"
        );
        console.error("API Error:", result);
      }
    } catch (error) {
      setLoading(false);
      Swal.fire("Error", "Network error. Please try again.", "error");
      console.error("Network Error:", error);
    }
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before proceeding to next.",
      });
      return;
    }
    Navigate("/class-xi-upload-document");
  };
  const handleChange = (e) => {
    const { name, value = "" } = e.target;
    let formattedValue = value;

    if (name === "fatheR_NAME" || name === "motheR_NAME") {
      formattedValue = value
        .toUpperCase()
        .replace(/[^A-Z\s]/g, "")
        .slice(0, 35);
    }

    setClass11exregulartudent((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };
  const formatDateForApi = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleChangeDate = (date) => {
    setClass11exregulartudent((prev) => ({
      ...prev,
      dob: date ? formatDateForApi(date) : "",
    }));
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div class="container-scroller">
        <Navbar11 />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div class="container-fluid page-body-wrapper">
          <Sidebar11 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header ">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Add Ex-Regular
                      Student (Student Registration Page for Board Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            Navigate("/class-xi-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student (JAC)</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Name of Student</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    className={`form-control form-control-sm ${
                                      errors.candidatE_NAME ? "is-invalid" : ""
                                    }`}
                                    name="candidatE_NAME"
                                    maxlength="35"
                                    placeholder="Cadidate Name"
                                    value={
                                      class11exregulartudent.candidatE_NAME ||
                                      ""
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <input
                                  type="text"
                                  value={class11exregulartudent.gender || ""}
                                  name="gender"
                                  className="form-select form-control-sm"
                                  disabled
                                ></input>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Date of Birth{" "}
                                  {fieldsMissing.dobMissing === true && (
                                    <span className="text-danger">*</span>
                                  )}
                                </label>
                                <DatePicker
                                  name="dob"
                                  selected={(() => {
                                    const rawDob =
                                      class11exregulartudent.dob ||
                                      class11exregulartudent.doB_1 ||
                                      "";

                                    if (!rawDob) return null;

                                    const [dd, mm, yyyy] = rawDob.split("-");

                                    // ✅ FIX — create local date, no timezone shift
                                    return new Date(
                                      Number(yyyy),
                                      Number(mm) - 1,
                                      Number(dd)
                                    );
                                  })()}
                                  minDate={new Date(1975, 0, 1)}
                                  maxDate={new Date()}
                                  onChange={handleChangeDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={`form-control form-control-sm ${
                                    errors.dob ? "is-invalid" : ""
                                  }`}
                                  placeholderText="dd-mm-yyyy"
                                  disabled={
                                    !fieldsMissing.dobMissing || isPreviewed
                                  }
                                  onKeyDown={(e) => e.preventDefault()}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Father’s Name
                                  {fieldsMissing.fatherMissing === true && (
                                    <span className="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="fatheR_NAME"
                                    disabled={
                                      !fieldsMissing.fatherMissing ||
                                      isPreviewed
                                    }
                                    onChange={handleChange}
                                    className={`form-control form-control-sm ${
                                      errors.fatheR_NAME ? "is-invalid" : ""
                                    }`}
                                    value={
                                      class11exregulartudent.fatheR_NAME || ""
                                    }
                                    maxLength="35"
                                    placeholder="Father’s Name"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Mother’s Name{" "}
                                  {fieldsMissing.motherMissing === true && (
                                    <span className="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="motheR_NAME"
                                    disabled={
                                      !fieldsMissing.motherMissing ||
                                      isPreviewed
                                    }
                                    onChange={handleChange}
                                    className={`form-control form-control-sm ${
                                      errors.motheR_NAME ? "is-invalid" : ""
                                    }`}
                                    value={
                                      class11exregulartudent.motheR_NAME || ""
                                    }
                                    maxlength="35"
                                    placeholder="Mother’s Name"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Religion</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={
                                    class11exregulartudent.religioN_NAME || ""
                                  }
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Nationality</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={
                                    class11exregulartudent.nationality || ""
                                  }
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group mb-3">
                                <label>Caste</label>
                                <select
                                  style={{ color: "black" }}
                                  className="form-control form-control-sm"
                                  name="caste_val"
                                  id="caste_val"
                                  value={class11exregulartudent.cast}
                                  disabled
                                >
                                  <option value=""></option>
                                  {casteList.map((caste) => (
                                    <option
                                      key={caste.castE_ID}
                                      value={caste.castE_ID}
                                    >
                                      {caste.castE_NAME}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-12">
                              <div class="form-group mb-3">
                                <label>Divyang</label>
                                <select
                                  style={{ color: "black" }}
                                  className="form-control form-control-sm"
                                  id="divyang_val"
                                  name="divyang_val"
                                  value={class11exregulartudent.divyang}
                                  disabled
                                >
                                  <option value="">Select</option>
                                  {divyangList.map((divyang) => (
                                    <option
                                      key={divyang.divyanG_ID}
                                      value={divyang.divyanG_ID}
                                    >
                                      {divyang.divyanG_NAME}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-12">
                              <div class="form-group mb-3">
                                <label>Medium of Examination</label>
                                <select
                                  style={{ color: "black" }}
                                  className="form-control form-control-sm"
                                  value={class11exregulartudent.mediuM_OF_EXAM}
                                  disabled
                                >
                                  <option value="">Select</option>
                                  {mediumList.map((medium) => (
                                    <option
                                      key={medium.mediuM_ID}
                                      value={medium.mediuM_ID}
                                    >
                                      {medium.mediuM_NAME}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Area</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={class11exregulartudent.area || ""}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-m-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice</label>
                                <input
                                  type="name"
                                  class="form-control form-control-sm"
                                  name="category_name"
                                  id="category_name"
                                  value={
                                    class11exregulartudent.studenT_EXAM_SUB_CATEGORY ||
                                    ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>

                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value={
                                    class11exregulartudent.board ||
                                    class11exregulartudent.boarD_NAME ||
                                    ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group mb-3">
                                <label>Stream</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value={
                                    class11exregulartudent.faculty ||
                                    class11exregulartudent.stream ||
                                    ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            {class11exregulartudent.faculty === "ARTS" ||
                            class11exregulartudent.stream === "ARTS" ? (
                              <>
                                <div class="col-md-12 mb-3" id="paper1">
                                  <h4>Core Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Core Language</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          // value={
                                          //   class11exregulartudent.suB1 ||
                                          //   class11exregulartudent.subjecT_1_A_CODE ||
                                          //   ""
                                          // }
                                          value={
                                            class11exregulartudent.subjecT_NAME1
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME1
                                                }${
                                                  class11exregulartudent.suB1 ||
                                                  class11exregulartudent.subjecT_1_A_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB1 ||
                                                        class11exregulartudent.subjecT_1_A_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Matri Bhasa</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          // value={
                                          //   class11exregulartudent.suB2 ||
                                          //   class11exregulartudent.subjecT_1_B_CODE ||
                                          //   ""
                                          // }
                                          value={
                                            class11exregulartudent.subjecT_NAME2
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME2
                                                }${
                                                  class11exregulartudent.suB2 ||
                                                  class11exregulartudent.subjecT_1_B_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB2 ||
                                                        class11exregulartudent.subjecT_1_B_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12 mb-3" id="arts_paper3">
                                  <h4>Elective Subject</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Elective Language</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          // value={
                                          //   class11exregulartudent.suB3 ||
                                          //   class11exregulartudent.subjecT_2_CODE ||
                                          //   ""
                                          // }
                                          value={
                                            class11exregulartudent.subjecT_NAME3
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME3
                                                }${
                                                  class11exregulartudent.suB3 ||
                                                  class11exregulartudent.subjecT_2_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB3 ||
                                                        class11exregulartudent.subjecT_2_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12 mb-3" id="arts_paper2">
                                  <h4>Optional Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 1</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME4
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME4
                                                }${
                                                  class11exregulartudent.suB4 ||
                                                  class11exregulartudent.subjecT_3_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB4 ||
                                                        class11exregulartudent.subjecT_3_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 2</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME5
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME5
                                                }${
                                                  class11exregulartudent.suB5 ||
                                                  class11exregulartudent.subjecT_4_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB5 ||
                                                        class11exregulartudent.subjecT_4_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 3</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME6
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME6
                                                }${
                                                  class11exregulartudent.suB6 ||
                                                  class11exregulartudent.subjecT_5_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB6 ||
                                                        class11exregulartudent.subjecT_5_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12" id="arts_additional">
                                  <h4>Additional Subject </h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4 mb-2">
                                      <div class="form-group mb-3">
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME7
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME7
                                                }${
                                                  class11exregulartudent.suB7 ||
                                                  class11exregulartudent.subjecT_6_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB7 ||
                                                        class11exregulartudent.subjecT_6_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div class="col-md-12 mb-3" id="paper1">
                                  <h4>Core Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Core Language</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME1
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME1
                                                }${
                                                  class11exregulartudent.suB1 ||
                                                  class11exregulartudent.subjecT_1_A_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB1 ||
                                                        class11exregulartudent.subjecT_1_A_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Matri Bhasa</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME2
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME2
                                                }${
                                                  class11exregulartudent.suB2 ||
                                                  class11exregulartudent.subjecT_1_B_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB2 ||
                                                        class11exregulartudent.subjecT_1_B_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12 mb-3" id="arts_paper2">
                                  <h4>Compulsory Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Compulsory 1</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME3
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME3
                                                }${
                                                  class11exregulartudent.suB3 ||
                                                  class11exregulartudent.subjecT_2_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB3 ||
                                                        class11exregulartudent.subjecT_2_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Compulsory 2</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME4
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME4
                                                }${
                                                  class11exregulartudent.suB4 ||
                                                  class11exregulartudent.subjecT_3_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB4 ||
                                                        class11exregulartudent.subjecT_3_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12 mb-3" id="arts_paper3">
                                  <h4>Optional Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 1</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME5
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME5
                                                }${
                                                  class11exregulartudent.suB5 ||
                                                  class11exregulartudent.subjecT_4_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB5 ||
                                                        class11exregulartudent.subjecT_4_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 2</label>
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME6
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME6
                                                }${
                                                  class11exregulartudent.suB6 ||
                                                  class11exregulartudent.subjecT_5_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB6 ||
                                                        class11exregulartudent.subjecT_5_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12" id="arts_additional">
                                  <h4>Additional Subject </h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4 mb-2">
                                      <div class="form-group mb-3">
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          name="board_name"
                                          id="board_name"
                                          value={
                                            class11exregulartudent.subjecT_NAME7
                                              ? `${
                                                  class11exregulartudent.subjecT_NAME7
                                                }${
                                                  class11exregulartudent.suB7 ||
                                                  class11exregulartudent.subjecT_6_CODE
                                                    ? ` (${
                                                        class11exregulartudent.suB7 ||
                                                        class11exregulartudent.subjecT_6_CODE
                                                      })`
                                                    : ""
                                                }`
                                              : ""
                                          }
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <h5 style={{ color: "red" }}>
                            <input
                              type="checkbox"
                              checked={isAgreed}
                              onChange={(e) => setIsAgreed(e.target.checked)}
                            />{" "}
                            I AGREE THAT ALL THE INFORMATION ABOVE IS CORRECT AS
                            PER MY BEST KNOWLEDGE.
                          </h5>
                        </div>

                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {class11exregularmode === "edit" ? (
                            <button
                              type="button"
                              onClick={handleContinueClick}
                              className="btn btn-success"
                            >
                              Next <i className="fa fa-arrow-right me-1"></i>
                            </button>
                          ) : isAllDataPresent ? (
                            <button
                              onClick={handleButtonClick}
                              type="button"
                              className="btn btn-primary pull-right"
                            >
                              <i className="fa fa-save me-1"></i> Submit
                            </button>
                          ) : isPreviewed ? (
                            // After preview: show Edit + Submit buttons
                            <>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-warning me-2"
                              >
                                Edit <i className="fa fa-edit me-1"></i>
                              </button>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-success"
                              >
                                Submit
                              </button>
                            </>
                          ) : (
                            // If missing fields and preview not clicked: show Preview button
                            <button
                              onClick={handlePreview}
                              type="button"
                              className="btn btn-primary pull-right"
                            >
                              <i className="fa fa-save me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer11 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Addexregularsecond11;
